
// Create Application Hours Stats Per Month
export const CREATE_APPLICATION_HOURS_STATS_PER_MONTH_REQUEST = 'CREATE_APPLICATION_HOURS_STATS_PER_MONTH_REQUEST';
export const CREATE_APPLICATION_HOURS_STATS_PER_MONTH_SUCCESS = 'CREATE_APPLICATION_HOURS_STATS_PER_MONTH_SUCCESS';
export const CREATE_APPLICATION_HOURS_STATS_PER_MONTH_FAILURE = 'CREATE_APPLICATION_HOURS_STATS_PER_MONTH_FAILURE';
export const CREATE_APPLICATION_HOURS_STATS_PER_MONTH_RESET = 'CREATE_APPLICATION_HOURS_STATS_PER_MONTH_RESET';

// Clear errors
export const CLEAR_APPLICATION_HOURS_STATS_PER_MONTH_ERRORS = 'CLEAR_APPLICATION_HOURS_STATS_PER_MONTH_ERRORS';
